import { memo, useMemo } from 'react';
import { SwitchCase } from '@toss/react';
import { useTranslation } from 'next-i18next';
import { focusField } from '../focus/focusUtils';
import { useQuizFormField } from './hook/useQuizFormField';
import { AiGenerateMultipleStatusProvider } from './Multiple/useAiGenerateMultipleStatus';
import { QuizTypeSelector } from './QuizTypeSelector/QuizTypeSelector';
import { AiGenerateSubjectiveStatusProvider } from './Subjective/AiGenerateSingleAnswer/useAiGeneateSubjectiveStatus';
import { EssayBody } from './EssayBody';
import { MultipleBody } from './MultipleBody';
import { OXBody } from './OXBody';
import { QuizCard } from './QuizCardUI';
import { useQuizControl } from './QuizControlProvider';
import { SubjectiveBody } from './SubjectiveBody';
export const Body = () => {
  const {
    index
  } = useQuizControl();
  const [type, _] = useQuizFormField({
    field: 'type'
  });
  const leftSlot = useMemo(() => <QuizIndicator />, []);
  return <QuizCard.Content onClick={() => {
    focusField(`quizList.${index}.question`);
  }} data-sentry-element="unknown" data-sentry-component="Body" data-sentry-source-file="Body.tsx">
      <SwitchCase value={type} caseBy={{
      multiple: <AiGenerateMultipleStatusProvider>
              <MultipleBody leftSlot={leftSlot} />
            </AiGenerateMultipleStatusProvider>,
      subjective: <AiGenerateSubjectiveStatusProvider>
              <SubjectiveBody leftSlot={leftSlot} />
            </AiGenerateSubjectiveStatusProvider>,
      ox: <OXBody leftSlot={leftSlot} />,
      essay: <EssayBody leftSlot={leftSlot} />
    }} data-sentry-element="SwitchCase" data-sentry-source-file="Body.tsx" />
    </QuizCard.Content>;
};
const QuizIndicator = memo(() => {
  const {
    t
  } = useTranslation(['build']);
  const {
    index
  } = useQuizControl();
  return <div className="flex flex-row items-center gap-sm text-heading-sm-bold">
      {t('build:build.quiz.questionNumber', {
      number: index + 1
    })}
      <QuizTypeSelector />
    </div>;
});